import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import OnewayPickupPeriodicHikeDayServices from "services/OnewayPeriodicHikeDayServices";
import { notifyError, notifySuccess } from "utils/toast";

const formatDateLocal = (date) => {
    if (!(date instanceof Date)) return null;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};


const useOnewayPickupPeriodicHikeDaySubmit = (id) => {
    const { isDrawerOpen, closeDrawer, setIsUpdate } =
        useContext(SidebarContext);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [fromCity, setFromCity] = useState(null);
    const [toCity, setToCity] = useState(null);

    const [dataInput, setDataInput] = useState([{ "vehicle_type_0": "", "hike_0": "" }]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedOptions, setSelectedOptions] = useState([]);


    const handleStartDateChange = (event) => {
        const selectedStartDate = event;
        setStartDate(selectedStartDate);
    };
    const handleVehicleCategoryChange = (e, index) => {
        const { name, value } = e.target;
        const onChangeVals = [...dataInput];
        onChangeVals[index][name] = value;
        setDataInput(onChangeVals);
        const updatedSelectedOptions = [...selectedOptions];
        updatedSelectedOptions[index] = value;
        setSelectedOptions(updatedSelectedOptions);
    };
    const {
        trigger,
        register,
        handleSubmit,
        setValue,
        clearErrors,
        formState: { errors },
    } = useForm();

    const handleFromCityChange = (city_id) => {
        setFromCity(city_id);
    };

    const handleToCityChange = (city_id) => {
        setToCity(city_id);
    };

    const handleChangeInput = (e, i) => {
        if (e && e.target) {
            const { name, value } = e.target;
            if (value === '0') {
                return;
            }
            const onChangeVal = [...dataInput];
            onChangeVal[i][name] = value;
            setDataInput(onChangeVal);
        }
    };
    const onSubmit = async (data) => {

        try {

            const dataValues = {};
            const vehicleTypeValues = dataInput.map(
                (item) => String(item[Object.keys(item)[0]])
            );

            const HikeValues = dataInput.reduce((acc, item) => {
                const key = item[Object.keys(item)[0]];
                const value = item[Object.keys(item)[1]];
                acc[key] = value;
                return acc;
            }, {});

            dataValues.vehicle_type = vehicleTypeValues;
            dataValues.hike = HikeValues;

            dataValues.from_city = fromCity;
            dataValues.to_city = toCity;
            dataValues.start_date = formatDateLocal(startDate);
            dataValues.end_date = formatDateLocal(endDate);

            if (id) {
                const res =
                    await OnewayPickupPeriodicHikeDayServices.updateOnewayPickupPeriodicHikeDay(
                        id,
                        dataValues
                    );
                notifySuccess(res.message);
            } else {
                const res =
                    await OnewayPickupPeriodicHikeDayServices.addOnewayPickupPeriodicHikeDay(
                        dataValues
                    );
                notifySuccess(res.message);
            }
            setIsUpdate(true);
            setIsSubmitting(false);
            closeDrawer();

        } catch (err) {
            notifyError(err?.response?.data?.message || err?.message);
            setIsSubmitting(false);
        }
    };
    const getOnewayPickupPeriodicHikeDayData = async () => {
        try {
            const res = await OnewayPickupPeriodicHikeDayServices.getOnewayPickupPeriodicHikeDayById(id);
            const data = res?.data;
            if (!data) return;

            const FormWholeArray = [];

            if (Array.isArray(data.vehicle_type_id)) {
                data.vehicle_type_id.forEach((item, index) => {
                    FormWholeArray.push({
                        [`vehicle_type_${index}`]: item,
                        [`hike_${index}`]: data.hike?.[item] ?? ""
                    });
                });

                setDataInput(FormWholeArray);
                setSelectedOptions(data.vehicle_type_id);

                data.vehicle_type_id.forEach((item, index) => {
                    setValue(`vehicle_type_${index}`, item);
                    setValue(`hike_${index}`, data.hike?.[item] ?? "");
                });
            }

            setFromCity(data.from_city_id || null);
            setToCity(data.to_city_id || null);

            const startDateObj = data.start_date ? new Date(data.start_date) : null;
            const endDateObj = data.end_date ? new Date(data.end_date) : null;

            setStartDate(
                startDateObj && !isNaN(startDateObj.getTime())
                    ? startDateObj
                    : null
            );

            setEndDate(
                endDateObj && !isNaN(endDateObj.getTime())
                    ? endDateObj
                    : null
            );

        } catch (err) {
            notifyError(err?.response?.data?.message || err?.message);
        }
    };





    useEffect(() => {
        if (!isDrawerOpen) {
            setDataInput([{ "vehicle_type_0": "", "hike_0": "" }]);
            setSelectedOptions([]);
            setFromCity(null);
            setToCity(null);

            setStartDate(null);
            setEndDate(null);
            clearErrors("start_date");
            clearErrors("end_date");
            clearErrors("city");
            clearErrors();
            return;
        }

        if (id) {
            getOnewayPickupPeriodicHikeDayData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, setValue, isDrawerOpen, clearErrors]);


    return {
        register,
        handleSubmit,
        onSubmit,
        fromCity,
        toCity,
        handleFromCityChange,
        handleToCityChange,
        trigger,
        errors,
        isSubmitting,
        handleVehicleCategoryChange,
        selectedOptions,
        setSelectedOptions,
        setDataInput,
        dataInput,
        handleChangeInput,
        startDate,
        handleStartDateChange,
        endDate,
        setEndDate,
    };
};

export default useOnewayPickupPeriodicHikeDaySubmit;
